import React, { useMemo } from 'react';
import RichTextEditor from '../../../components/ui/RichTextEditor';
import SiteFontStyles from './SiteFontStyles';
import { resolveInheritedFontStyle, resolveFontFamilyChoice } from '../utils/defaults';
import { buildEditorFontWhitelist, resolveDefaultQuillFontKey } from '../utils/siteFonts';
import { isRichTextMostlyLight } from '../utils/richTextContrast';
import { resolveTextBlockTypographyStyle } from '../utils/textBlockTypography';
import '../styles/webCreatorRichText.css';

export default function WebCreatorTextEditor({
  value,
  onChange,
  inheritSiteFont = true,
  textFontFamily = 'system',
  siteTypography,
  paddingStyle,
  typographyProps,
}) {
  const html = value || '<p><br></p>';
  const previewFontStyle =
    inheritSiteFont !== false
      ? resolveInheritedFontStyle(siteTypography)
      : { fontFamily: resolveFontFamilyChoice(textFontFamily, siteTypography) };

  const fontWhitelist = useMemo(
    () => buildEditorFontWhitelist(siteTypography),
    [siteTypography],
  );

  const defaultQuillFontKey = useMemo(
    () => resolveDefaultQuillFontKey(inheritSiteFont, textFontFamily, siteTypography),
    [inheritSiteFont, textFontFamily, siteTypography],
  );

  const darkPreview = useMemo(() => isRichTextMostlyLight(html), [html]);
  const blockTypographyStyle = useMemo(
    () => resolveTextBlockTypographyStyle(typographyProps || {}),
    [typographyProps],
  );

  return (
    <>
      <SiteFontStyles typography={siteTypography} />
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
      <div className="min-w-0">
        <p className="text-xs font-semibold text-foreground mb-2">Éditeur</p>
        <RichTextEditor
          key={`${defaultQuillFontKey}|${fontWhitelist.join(',')}`}
          value={html}
          onChange={onChange}
          minEditorHeight={280}
          placeholder="Rédigez votre contenu…"
          fontWhitelist={fontWhitelist}
          adaptiveDarkChrome={darkPreview}
          defaultEditorFontFamily={previewFontStyle.fontFamily}
        />
      </div>
      <div className="min-w-0">
        <p className="text-xs font-semibold text-foreground mb-2">Aperçu en direct</p>
        <div
          className={`rounded-lg border border-border bg-background overflow-auto web-creator-rich-text${
            darkPreview ? ' web-creator-rich-text--dark-preview' : ''
          }`}
          style={{
            minHeight: 320,
            ...paddingStyle,
            ...previewFontStyle,
            ...blockTypographyStyle,
          }}
        >
          <div className="p-4" dangerouslySetInnerHTML={{ __html: html }} />
        </div>
      </div>
      </div>
    </>
  );
}
